<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 240px'>
        <p>对账单编号：</p>
        <el-input v-model='queryForm.settNo' size='mini' style='width:150px'
                  placeholder='请输入对账单编号' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>对账单标题：</p>
        <el-input v-model='queryForm.title' size='mini' style='width:150px'
                  placeholder='请输入对账单标题' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>公司名称：</p>
        <el-input v-model='queryForm.companyNameNew' size='mini' style='width:150px'
                  placeholder='请输入公司名称' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>结算方式：</p>
        <el-select v-model='queryForm.settType' filterable size='mini' style='width:150px'
                   placeholder='请选择结算方式'>
          <el-option v-for='item in settTypeOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          :expand-row-keys='expands'
          :row-key='bindRowKeys'
        >
          <el-table-column label='序号' align='center' type='index' />
          <el-table-column prop='settNo' label='对账单编号' align='center' />
          <el-table-column prop='title' label='标题' align='center' />
          <el-table-column prop='companyNameNew' label='委托商' align='center' show-overflow-tooltip />
          <el-table-column label='结算方式' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.settType === 1 ? '合同价' : '预结算价' }}
            </template>
          </el-table-column>
          <el-table-column label='含税费用' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.settType === 1 ? scope.row.taxPrice : scope.row.taxSettPrice }}
            </template>
          </el-table-column>
          <el-table-column label='不含税费用' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.settType === 1 ? scope.row.noTaxPrice : scope.row.noTaxSettPrice
              }}
            </template>
          </el-table-column>
          <el-table-column prop='billingNum' label='开票数量' align='center' />
          <el-table-column label='状态' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.status | accountStatus }}
            </template>
          </el-table-column>
          <el-table-column label='操作' align='center'>
            <template slot-scope='innerScope'>
              <div
                style='display:flex;align-items:center;padding-left: 10px;justify-content: center'>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(innerScope.row.id)'>详情
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <!-- 详情对话框 start -->
    <el-dialog title='详情' :visible.sync='detailDialogVisible' :width='detailDialogWidth'
               @close='detailClose' center top='10vh'>
      <div class='detail'>
        <el-tabs v-model='activeName'>
          <el-tab-pane label='基础信息' name='first'>
            <div class='baseInfo'>
              <div class='baseInfoContent'>
                <div class='baseInfoContentItem'>
                  <span class='span1'>对账单编号：</span>
                  <span>{{ detailData.settNo }}</span>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>标题：</span>
                  <span>{{ detailData.title }}</span>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>委托商：</span>
                  <span>{{ detailData.companyNameOld }}</span>
                  <el-tooltip v-if='detailData.companyNameOld != detailData.companyNameNew'
                              placement='bottom' effect='light'>
                    <div slot='content'>
                      <span style='color: #999;'>原委托商名称：{{ detailData.companyNameNew }}</span>
                    </div>
                    <i class='el-icon-warning'
                       style='color: red;font-size: 18px;margin-right: 5px;' />
                  </el-tooltip>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>结算方式：</span>
                  <span v-show='detailData.settType===1'>合同价</span>
                  <span v-show='detailData.settType===2'>预结算价</span>
                </div>
                <div class='baseInfoContentItem specialItem'>
                  <div class='specialOne'>
                    <span class='span1'>合计含税费用：</span>
                    <span>{{ (detailData.settType === 1 ? detailData.taxPrice : detailData.taxSettPrice)
                    || 0 }}元</span>
                    <el-tooltip placement='bottom' effect='light'>
                      <div slot='content'>
                        <span style='color: #999;'>
                          结算费用{{ (detailData.settType === 1 ? detailData.taxPrice : detailData.taxSettPrice) || 0
                          }}元
                        </span><br />
                        <span style='color: #999;'>
                          其他结算费用
                          {{ (detailData.settType === 1 ? detailData.noTaxPrice : detailData.noTaxSettPrice) || 0
                          }}元
                        </span><br />
                      </div>
                      <i class='el-icon-warning'
                         style='color: red;font-size: 18px;margin-right: 5px;' />
                    </el-tooltip>
                  </div>
                  <div>
                    <span class='span1'>合计不含税费用：</span>
                    <span>{{ (detailData.settType === 1 ? detailData.noTaxPrice : detailData.noTaxSettPrice) || 0
                      }}元</span>
                  </div>
                </div>
                <!--                <div class="baseInfoContentItem">-->
                <!--                  <span class="span1">生成对账单时间：</span>-->
                <!--                  <span>{{detailData.time2}}</span>-->
                <!--                </div>-->
              </div>
            </div>
            <div class='operation' v-if='detailData.isDeduct==1'>
              <div class='operationTitle'>
                <div class='line' />
                <span>抵扣对账单</span>
              </div>
              <div class='operationTable'>
                <el-table :data='detailData.table1' border>
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column prop='operateType' label='对账单编号' align='center' />
                  <el-table-column prop='operationName' label='抵扣费用' align='center' />
                </el-table>
              </div>
            </div>
            <div class='baseInfo' v-if='detailData.status==1'>
              <div class='baseInfoTitle'>
                <div class='line' />
                <span>审核信息</span>
              </div>
              <div>
                <steps :step-data='stepData' :step-state='stepState' />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label='结算费用' name='second'>
            <div class='baseInfo'>
              <div class='operationTable' style='margin-top:0;'>
                <el-table
                  :data='detailTable'
                  border
                  script
                >
                  <el-table-column prop='batchNumber' label='批次号' min-width='100' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='waybillNo' label='运单号' min-width='120' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='frameNumber' label='车架号' min-width='150' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='brandName' label='品牌' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='modelName' label='型号' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='departurePlace' label='起始地' min-width='150' align='center'
                                   show-overflow-tooltip>
                    <template slot-scope='scope'>
                      {{
                        scope.row.departurePlaceType == 1 ? scope.row.departurePlace : scope.row.departurePort
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop='arrivePlace' label='交车地' min-width='150' align='center'
                                   show-overflow-tooltip>
                    <template slot-scope='scope'>
                      {{
                        scope.row.arrivePlaceType == 1 ?
                          scope.row.arrivePlace : scope.row.arrivePort
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop='standingBookMonth' label='台账月' min-width='100'
                                   align='center' show-overflow-tooltip />
                  <el-table-column v-if='settlement === 1' prop='taxContractPrice' label='含税合同价'
                                   align='center' show-overflow-tooltip />
                  <el-table-column v-else prop='taxPreparePrice' label='含税预结算价' align='center'
                                   show-overflow-tooltip />
                  <el-table-column v-if='settlement === 1' prop='contractPrice' label='不含税合同价'
                                   align='center' show-overflow-tooltip />
                  <el-table-column v-else prop='preparePrice' label='不含税预结算价' align='center'
                                   show-overflow-tooltip />
                </el-table>
              </div>
              <div class='paginationContainer'
                   style='display: flex;align-items: center;padding: 10px 20px;'>
                <span>共{{ detailTotal }}条</span>
                <el-pagination
                  background
                  :page-sizes='[10, 20, 30, 40]'
                  layout='sizes,prev, pager, next,jumper'
                  :total='detailTotal'
                  @size-change='detailSizeChange'
                  @current-change='detailCurrentChange'
                  @prev-click='detailCurrentChange'
                  @next-click='detailCurrentChange'
                />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label='其它结算费用' name='third'>
            <div class='baseInfo'>
              <div class='operationTable' style='margin-top:0'>
                <el-table
                  :data='detailTable3'
                  border
                  script
                >
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column prop='type' label='费用编号' align='center' />
                  <el-table-column prop='remark2' label='费用类型' align='center' />
                  <el-table-column prop='batch' label='费用说明' align='center' />
                  <el-table-column prop='price' label='费用时间' align='center' />
                  <el-table-column prop='remark' label='税率(%)' align='center' />
                  <el-table-column prop='remark' label='含税价' align='center' />
                  <el-table-column prop='remark' label='不含税价' align='center' />
                  <el-table-column prop='remark' label='说明' align='center' />
                </el-table>
              </div>
              <div class='paginationContainer'
                   style='display: flex;align-items: center;padding: 10px 20px;'>
                <span>共{{ detailTotal3 }}条</span>
                <el-pagination
                  background
                  :page-sizes='[10, 20, 30, 40]'
                  layout='sizes,prev, pager, next,jumper'
                  :total='detailTotal3'
                  @size-change='detail3SizeChange'
                  @current-change='detail3CurrentChange'
                  @prev-click='detail3CurrentChange'
                  @next-click='detail3CurrentChange'
                />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label='开票信息'
                       v-if='detailData.status!=0&&detailData.status!=1&&detailData.status!=2'
                       name='fourth'>
            <div class='baseInfo'>
              <div class='baseInfoContent' style='padding: 0'>
                <div class='baseInfoContentItem'>
                  <span class='span1'>是否抵扣开票：</span>
                  <span>{{ detailData.time2 }}</span>
                </div>
                <div class='baseInfoContentItem'>
                  <span class='span1'>抵扣开票费用编号：</span>
                  <span>{{ detailData.time2 }}</span>
                </div>
                <div class='baseInfoContentItem specialItem'>
                  <div class='specialOne'>
                    <span class='span1'>原开票金额：</span>
                    <span>{{ detailData.customerNatureName }}</span>
                  </div>
                  <div>
                    <span class='span1'>抵扣金额：</span>
                    <span>{{ detailData.customerScaleName }}</span>
                  </div>
                </div>
              </div>
              <div class='operationTable' style='margin-top:0'>
                <el-table
                  :data='detailTable2'
                  border
                  script
                >
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column prop='type' label='发票号码' align='center' />
                  <el-table-column prop='remark2' label='发票金额' align='center' />
                  <el-table-column prop='batch' label='发票日期' align='center' />
                  <el-table-column prop='rate' label='发票类型' align='center' />
                  <el-table-column prop='price' label='发票税率' align='center' />
                  <el-table-column prop='price2' label='核销期限' align='center' />
                  <el-table-column prop='remark' label='创建日期' align='center' />
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!-- 详情对话框 end -->
  </div>
</template>

<script>
import steps from '@/components/steps'
import { formatDateTime } from '@/config/mUtils'
import divBorder from '@/components/divBorder'
import {
  getFinancePageList, getPageListSCFI, getPageListSOCI, getStatementAuditInfo
} from '@/service/getData'

export default {
  components: {
    steps,
    divBorder
  },
  data() {
    return {
      queryForm: {
        settNo: '',
        title: '',
        companyNameNew: '',
        type: 1,
        settType: '',
        page: 1,
        rows: 10
      },
      settTypeOption: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 1,
          label: '合同价'
        },
        {
          value: 2,
          label: '预结算价'
        }
      ],
      page: 1,
      size: 10,
      total: 0,
      tableLoad: false,
      TableDatas: [],
      detailDialogVisible: false,
      detailDialogWidth: '1050px',
      detailData: {
        table1: []
      },
      operationData: [],
      nameOption: [],
      payOption: [],
      addressOption: [],
      carVisible: false,
      selectedCar: [],
      selectCar: [],
      brands: [],
      models: [],
      brands2: [],
      models2: [],
      selectBrand: [],
      selectModel: [],
      allCar: [],
      allModel: [],
      expands: [],
      activeName: 'first',
      detailTable: [],
      detailTotal: 0,
      detailSize: 10,
      detailPage: 1,
      detailTable2: [],
      detailTable3: [],
      detailTotal3: 0,
      detailSize3: 10,
      detailPage3: 1,
      stepData: [],
      basicId: 0,
      settlement: 1// 结算方式 1：合同价 2：预结算价
    }
  },
  watch: {
    activeName(val) {
      if (val === 'second') {
        this.getPageListSCFI()
      } else if (val === 'third') {
        this.getPageListSOCI()
      }
    }
  },
  computed: {
    stepState() {
      return function(state) {
        switch (state) {
          case '':
            return 'wait'
          case 'success':
            return 'success'
          case 'failure':
            return 'error'
        }
      }
    },
    getState() {
      return function(state) {
        switch (state) {
          case 0:
            return '待生效'
          case 1:
            return '生效中'
          case 2:
            return '已失效'
        }
      }
    },
    getTime() {
      return function(time) {
        return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss')
      }
    }
  },
  filters: {
    accountStatus(value) {
      let returnStr = ''
      switch (value) {
        case 0:
          returnStr = '待提交审核'
          break
        case 1:
          returnStr = '审核对账单中'
          break
        case 2:
          returnStr = '系统开票中'
          break
        case 3:
          returnStr = '填写快递单号'
          break
        case 4:
          returnStr = '已收款'
          break
        case -1:
          returnStr = '审核未通过'
          break
        case -2:
          returnStr = '系统开票失败'
          break
        case -10:
          returnStr = '已取消'
          break
        default:
          returnStr = '--'
          break
      }
      return returnStr
    }
  },
  mounted() {
    this.getFinancePageList()
  },
  methods: {
    async getFinancePageList() {
      this.tableLoad = true
      let res = await getFinancePageList(this.queryForm)
      this.tableLoad = false
      if (res.status !== 0) return this.$message.error(res.methods)
      this.total = res.data.total
      this.TableDatas = res.data.records
    },
    compareDate(d1, d2) {
      return ((new Date(d1.replace(/-/g, '\/'))) > (new Date(d2.replace(/-/g, '\/'))))
    },
    // 结束时间
    dateChange(val) {
      if (this.timeIpt[1] && this.timeIpt[0] && this.compareDate(this.timeIpt[0], this.timeIpt[1])) {
        if (val == this.timeIpt[1]) this.timeIpt[1] = ''
        if (val == this.timeIpt[0]) this.timeIpt[0] = ''
        this.$forceUpdate()
        return this.$message.warning('结束日期必须大于开始日期！')
      }
    },
    //主页面条数
    contractSizeChange(sizes) {
      this.queryForm.rows = sizes
      this.getFinancePageList()
    },
    //主页面页数
    contractCurrentChange(page) {
      this.queryForm.page = page
      this.getFinancePageList()
    },
    detailClose() {
      this.detailDialogVisible = false
      this.activeName = 'first'
    },
    bjDate(date, date1) {
      var date = new Date(date)
      var date1 = new Date(date1)
      // 减小于0 date<date1
      return date.getTime() - date1.getTime() < 0
    },
    nameChange() {
    },
    carClick() {
      this.carVisible = true
      this.selectCar = [...this.selectedCar]
      this.brands = [...this.brands2]
      this.models = [...this.models2]
    },
    selectRemove(item) {
      this.selectCar.splice(this.selectCar.indexOf(item), 1)
      if (this.brands.indexOf(item) !== -1) {
        this.brands.splice(this.brands.indexOf(item), 1)
      } else {
        this.models.splice(this.models.indexOf(item), 1)
      }
    },
    brandAdd(item) {
      if (this.selectCar.indexOf(item) !== -1) return this.$message.warning('已选择该品牌！')
      let arr = []
      for (let i = 0; i < this.allCar.length; i++) {
        if (this.allCar[i].id === item.id) {
          arr = this.allCar[i].carModel
          break
        }
      }
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < this.selectCar.length; j++) {
          if (arr[i].id === this.selectCar[j].id) {
            this.selectCar.splice(j, 1)
            j--
          }
        }
      }
      this.selectCar.push(item)
      this.brands.push(item)
    },
    modelAdd(item) {
      for (let i = 0; i < this.selectCar.length; i++) {
        if (this.selectCar[i].id === item.brandId) {
          return this.$message.warning('上方已选择该品牌的全部车型！')
        } else if (this.selectCar[i].id === item.id) return this.$message.warning('已选择该车型！')
      }
      this.selectCar.push(item)
      this.models.push(item)
    },
    carAddClick() {
      this.carVisible = false
      this.selectedCar = [...this.selectCar]
      this.brands2 = [...this.brands]
      this.models2 = [...this.models]
    },

    carClose() {
      this.carVisible = false
    },
    brandClick(id) {
      for (let i = 0; i < this.allCar.length; i++) {
        if (this.allCar[i].id === id) {
          this.selectModel = this.allCar[i].carModel.map(item => {
            return {
              id: item.id,
              name: item.brand_name,
              brandId: item.brand_id
            }
          })
          break
        }
      }
    },
    deleteClick() {
      this.$confirm('确认删除当前对账单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
        })
        .catch(() => {
        })
    },
    hiddenClick(index, row) {
      this.TableDatas[index].tableShow = !this.TableDatas[index].tableShow
      Array.prototype.remove = function(val) {
        let index = this.indexOf(val)
        if (index > -1) {
          this.splice(index, 1)
        }
      }
      if (this.expands.indexOf(row.id) < 0) {
        this.expands.push(row.id)
      } else {
        this.expands.remove(row.id)
      }
    },
    disableClick() {
      this.$confirm('确认要取消审核申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
        })
        .catch(() => {
        })
    },
    async detailClick(id) {
      const {
        status,
        data,
        message
      } = await getStatementAuditInfo(id)

      if (status === 0) {
        this.basicId = id
        this.detailDialogVisible = true
        this.settlement = data.settType
        this.detailData = data
        if (data.auditRecordList) {
          this.stepData = []
          // 审核信息数据
          data.auditRecordList.forEach(res => {
            const str = this.strFormat(res.status)
            const state = res.status == 3 ? 'failure' : res.status == 2 ? 'success' : ''
            this.stepData.push({
              title: res.auditorName + str,
              time: res.createTime,
              state,
              remark: res.opinion
            })
          })
        }
      } else {
        this.$message.warning(message)
      }
    },
    invoiceClick() {
      this.invoiceVisible = true
      this.invoiceData = {
        type: 1
      }
    },
    searchBtn() {
      this.page = 1
      this.getFinancePageList()
    },
    resetBtn() {
      this.queryForm = {
        settNo: '',
        title: '',
        companyNameNew: '',
        type: 1,
        settType: '',
        page: 1,
        rows: 10
      }
    },
    auditClick(id) {
      this.auditVisible = true
      this.auditData = {
        deduction: 1,
        invoice: 1,
        type: 1,
        total: 500,
        maxPrice: 100,
        num: 2,
        invoicePrice: 0,
        table: [
          {
            num: '1231231231',
            max: 12,
            price: 10
          }
        ],
        table2: [
          { price: 100 },
          { price: 200 }
        ]
      }
    },
    bindRowKeys(row) {
      return row.id
    },
    // 结算费用条数
    detailSizeChange(size) {
      this.detailSize = size
      this.getPageListSCFI()
    },
    // 结算费用页数
    detailCurrentChange(page) {
      this.detailPage = page
      this.getPageListSCFI()
    },
    // 其他结算费用条数
    detail3SizeChange(size) {
      this.detailSize3 = size
      this.getPageListSOCI()
    },
    // 其他结算费用页数
    detail3CurrentChange(page) {
      this.detailPage3 = page
      this.getPageListSOCI()
    },
    async getPageListSCFI() {
      const {
        status,
        message,
        data: {
          records,
          total
        }
      } = await getPageListSCFI({
        id: this.basicId,
        page: this.detailPage,
        rows: this.detailSize
      })
      if (status === 0) {
        this.detailTable = records
        this.detailTotal = total
      } else {
        this.$message.warning(message)
      }
    },
    async getPageListSOCI() {
      const {
        status,
        message,
        data: {
          records,
          total
        }
      } = await getPageListSOCI({
        id: this.basicId,
        page: this.detailPage3,
        rows: this.detailSize3
      })
      if (status === 0) {
        this.detailTable3 = records
        this.detailTotal3 = total
      } else {
        this.$message.warning(message)
      }
    },
    // 格式化审核信息状态
    strFormat(val) {
      let returnStr = ''
      switch (val) {
        case 0:
          returnStr = ' 重新发起'
          break
        case 1:
          returnStr = ' 发起'
          break
        case 2:
          returnStr = ' 同意'
          break
        case 3:
          returnStr = ' 拒绝'
          break
        case 4:
          returnStr = ' 取消审核'
          break
        default:
          returnStr = ''
          break
      }
      return returnStr
    }
  }
}
</script>


<style lang='scss' scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableContainer {
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;

      ::v-deep {
        .el-table__expand-icon:after {
          content: '';
        }

        .el-table__expand-icon > i {
          display: none;
        }

        .el-table__expand-column {
          border-right: none;
        }

        body .el-table th.gutter {
          display: table-cell !important;
        }

        .el-badge__content {
          top: 4px !important;
          right: 1px !important;
        }

        .el-badge__content {
          background-color: #F56C6C !important;
        }

        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .carContainer {
    width: 100%;
    padding: 15px 40px 10px 20px;
    max-height: 75vh;
    overflow: auto;

    &Title {
      display: flex;
      flex-direction: column;

      span {
        color: #101010;
        font-weight: 700;
        margin-bottom: 5px;
      }

      &Content {
        width: 100%;
        padding-left: 15px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 10px;

        &Item {
          height: 25px;
          padding: 0 5px;
          background-color: #a4adb3;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-right: 10px;
          margin-bottom: 5px;

          i {
            color: #000;
            font-size: 17px;
            cursor: pointer;
          }

          p {
            cursor: pointer;
          }
        }
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }

  .detail {
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height: 80vh;
    overflow: auto;

    ::v-deep {
      .el-table td, .el-table th {
        padding: 0;
      }

      .cell {
        font-size: 10px;
        padding: 0;
      }
    }

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;

        &Item {
          margin-bottom: 20px;

          .imgContainer {
            display: flex;
            align-items: center;
          }

          .span1 {
            font-weight: 700;
          }

          span {
            font-size: 14px;
          }

          .specialOne {
            width: 50%;
          }
        }

        .specialItem {
          display: flex;
        }
      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      ::v-deep {
        .el-table .ui-warning-row {
          background-color: #fef0f0 !important;
        }

        .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
          background-color: #fef0f0 !important;
        }

        .el-table .ui-warning-row .cell {
          color: red;
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding: 0 20px;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .reasonContainer {
    width: 100%;
    padding: 20px 30px;

    ::v-deep {
      .el-textarea__inner {
        min-height: 100px !important;
      }
    }

    .reasonBtn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .addCost {
    display: flex;
    flex-direction: column;
    padding: 10px 40px 10px 10px;
    max-height: 75vh;
    overflow: auto;

    &Nav {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &Table {
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;

      ::v-deep {
        .el-table__expand-icon:after {
          content: '';
        }

        .el-table__expand-icon > i {
          display: none;
        }

        .el-table__expand-column {
          border-right: none;
        }

        body .el-table th.gutter {
          display: table-cell !important;
        }

        .el-table__header .el-table-column--selection .cell .el-checkbox:after {
          color: rgb(127, 127, 127);
          content: "全选";
          font-size: 12px;
          font-weight: 700;
          //margin-left: 2px;
        }

        .el-table__header .el-table-column--selection .cell .el-checkbox {
          margin-left: 8px;
        }

        .el-checkbox {
          margin-left: 16px;
        }

        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .depart {
    width: 100%;
    padding: 10px 40px 10px 10px;
    max-height: 75vh;
    overflow: auto;

    &Table {
      margin-bottom: 25px;
      width: 100%;

      .tableAddBtnContainer {
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;

        .AddContainer {
          display: flex;
          align-items: center;

          &:hover {
            cursor: pointer;
          }
        }

        img {
          object-fit: cover;
          margin-right: 5px;
        }

        p {
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }

      ::v-deep {
        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .specialItem {
      ::v-deep {
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }
    }

    ::v-deep {
      .el-form-item__label {
        font-weight: 700;
      }

      .el-form-item {
        margin-bottom: 13px;
      }

      .el-form-item__label {
        padding: 0;
      }

      .el-form-item__content {
        position: relative;
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }

  ::v-deep {
    .el-table th > .cell {
      font-weight: 700 !important;
    }
  }
}

::v-deep {
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .el-dialog__headerbtn {
    top: 9px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>
